function copyToClipboard(str){
  var el=document.createElement("textarea");
  el.value=str;
  el.setAttribute("readonly","");
  el.style.position="absolute";
  el.style.left="-9999px";
  document.body.appendChild(el);
  var selected=document.getSelection().rangeCount>0?document.getSelection().getRangeAt(0):false;el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
  if(selected){
    document.getSelection().removeAllRanges();document.getSelection().addRange(selected)
  }
}
function copyCode(e){
  var $this=e.target;
  copyToClipboard($this.getAttribute("data-code"));
  var zfc = $this.getAttribute("data-code");
  $this.innerText="copied!";
  setTimeout((function(){$this.innerText=zfc}),1500)
}